export const prizeDialogData = (prizeData, pageInfo) => {
  const { productCode, productName, productType, singleDistributionCount } =
    prizeData;
  const isWin = productType == 2; // 是否中奖
  const prizeUrl = pageInfo?.prizes?.prizeData?.find(
    (item) => item.productCode === productCode,
  )?.val;
  const winBg = pageInfo?.visual?.prizeSetting?.[2]?.content?.[0].val;
  const noWinBg = pageInfo?.visual?.prizeSetting?.[2]?.content?.[1].val;
  const data = {
    isWin,
    prizeUrl,
    winBg,
    noWinBg,
    productName,
    singleDistributionCount,
  };
  console.log("pageInfo?.visual?.prizeSetting", pageInfo?.visual?.prizeSetting);
  return data;
};
